module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "heading-cart cf"
  }, [_c('h1', [_vm._v("Publishers")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": ("" + ('/admin/publisher/add/'))
    }
  }, [_vm._v("Add Publisher")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('div', [_c('el-header', [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-tools pull-right"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "offset": 9
    }
  }, [_c('p', {
    staticClass: "headingName"
  }, [_vm._v(" Add Publisher to Automatad")])])], 1), _vm._v(" "), _c('el-main', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }), _vm._v(" "), _c('div', {}, [_c('el-row', {
    attrs: {
      "gutter": 18
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6,
      "offset": 6
    }
  }, [_c('p', {
    staticClass: "paragraphBold"
  }, [_vm._v("Name")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Please input"
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('p', {
    staticClass: "paragraphBold"
  }, [_vm._v("Add Publisher")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Please input"
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 18
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6,
      "offset": 6
    }
  }, [_c('p', {
    staticClass: "paragraphBold"
  }, [_vm._v("Name")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Please input"
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('p', {
    staticClass: "paragraphBold"
  }, [_vm._v("Add Publisher")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Please input"
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 18
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6,
      "offset": 6
    }
  }, [_c('p', {
    staticClass: "paragraphBold"
  }, [_vm._v("Name")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Please input"
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('p', {
    staticClass: "paragraphBold"
  }, [_vm._v("Add Publisher")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Please input"
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "buttonMargin",
    attrs: {
      "span": 8,
      "offset": 16
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "cart-items width-100 pull-left pl-60 pr-30 pb-0 pt-0 container-fluid"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.publishers), function(option) {
    return _c('li', {
      staticClass: "row"
    }, [_c('span', {
      staticClass: "cart-image col-xs-12 col-sm-12 col-md-2"
    }, [_c('router-link', {
      staticClass: "h5",
      attrs: {
        "to": ("" + ('/admin/publisher-info/' + option.uuid + '/' + option.id))
      }
    }, [_c('avatar', {
      attrs: {
        "username": option.name,
        "size": 50,
        "color": "#fff"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "cart-item-right col-md-10 col-xs-12 col-sm-12"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('span', {
      staticClass: "cart-description col-xs-12 col-md-5"
    }, [_c('router-link', {
      staticClass: "h5",
      attrs: {
        "to": ("" + ('/admin/publisher-info/' + option.uuid + '/' + option.id))
      }
    }, [_vm._v(_vm._s(("" + (option.name))))])], 1), _vm._v(" "), _c('span', {
      staticClass: "col-md-5 col-sm-12 text-right"
    }, [_c('router-link', {
      staticClass: "hoverColor",
      attrs: {
        "to": ("" + ('/admin/publisher/edit/' + option.uuid + '/'))
      }
    }, [_c('span', {
      staticClass: "ti-pencil-alt pull-right mt-5 ml-10"
    })])], 1)])])])
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "cart-items-labels visible-lg-block visible-md-block row"
  }, [_c('span', {
    staticClass: "col-md-6 text-muted small"
  }, [_vm._v("Publisher")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1371c6f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/admin/Publisher.vue
// module id = 661
// module chunks = 2